
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 2.666a5.333 5.333 0 100 10.667A5.333 5.333 0 008 2.666zM1.335 8a6.667 6.667 0 1113.333 0A6.667 6.667 0 011.334 8zm9.776-2.165c.275.244.3.666.056.94l-3.556 4a.667.667 0 01-.997 0l-1.777-2a.667.667 0 01.996-.885l1.28 1.44 3.057-3.44a.667.667 0 01.941-.055z","fill":"#008C89"}})])
          )
        }
      }
    